import React, {Component} from 'react';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {ButtonIcon} from '@homeaway/react-buttons';
import {Link} from 'react-router-dom';
import {CHEVRON_RIGHT__12, CHEVRON_LEFT__12} from '@homeaway/svg-defs';
import {HomeRouteContext} from 'utils/context';
import ProgressiveImage from '../ProgressiveImage/ProgressiveImage';
import './HomeCarousel.less';

const CurrentSlideIndicator = (props) => {
    const {current, numberOfItems} = props;

    const formattedNumber = (num) => {
        return `0${num}`.slice(-2);
    };

    return (
        <div className="HomeCarousel__index hidden-xs">
            <p>
                <span>{formattedNumber(current + 1)}</span>
                {'/'}
                <span className="text-muted">
                    {formattedNumber(numberOfItems)}
                </span>
            </p>
        </div>
    );
};

const CurrentSlideProgressBar = (props) => {
    const {current, numberOfItems} = props;
    const indexAsPercent = ((current + 1) / numberOfItems) * 100;
    return (
        <div className="HomeCarousel__index-bar-wrap hidden-xs hidden-sm">
            <div
                className="HomeCarousel__index-bar"
                style={{
                    /* stylelint-disable */
                    right: `${100 - indexAsPercent}%`,
                }}
            />
        </div>
    );
};

const CarouselButtons = (props) => {
    const {handlePrev, handleNext, currentIndex, numberOfItems} = props;
    return (
        <div className="HomeCarousel__buttons">
            <ButtonIcon
                circle
                onClick={handlePrev}
                label="Previous"
                size="lg"
                svgMarkup={CHEVRON_LEFT__12}
                className="HomeCarousel__button HomeCarousel__button--prev"
                disabled={currentIndex < 1}
            />
            <ButtonIcon
                circle
                onClick={handleNext}
                label="Next"
                size="lg"
                svgMarkup={CHEVRON_RIGHT__12}
                className="HomeCarousel__button HomeCarousel__button--next"
                disabled={currentIndex === numberOfItems - 1}
            />
        </div>
    );
};

class HomeCarousel extends Component {
    static contextType = HomeRouteContext;

    state = {
        index: 0,
    };

    numberOfItems = this.props.articles && this.props.articles.length;

    handlePrev = () => {
        let index = this.state.index;
        if (index > 0) {
            this.setState({index: index - 1});
        }
    };

    handleNext = () => {
        let index = this.state.index;
        if (index < this.numberOfItems - 1) {
            this.setState({index: index + 1});
        }
    };

    render() {
        const {articles, isMobile} = this.props;
        const homeRoute = this.context;
        const current = this.state.index;

        if (articles.length < 1) {
            return null;
        }

        const {title, path, parent, overview} = articles[current];
        const articleImages = articles.map((article, i) => {
            if (i > current + 1) {
                return null;
            }

            return (
                <ProgressiveImage
                    src={article.heroFile.url}
                    alt={article.heroFile.title}
                    fit="fill"
                    className="HomeCarousel__image"
                    aria-hidden={current !== i}
                    key={i}
                    style={{
                        transform: `translateX(${(i - current) * 100}%)`,
                    }}
                    critical
                />
            );
        });

        const carouselButtons = (
            <CarouselButtons
                handlePrev={this.handlePrev}
                handleNext={this.handleNext}
                currentIndex={current}
                numberOfItems={this.numberOfItems}
            />
        );

        return (
            <section className="HomeCarousel">
                <div className="HomeCarousel__image-box">
                    <figure>{articleImages}</figure>
                    {isMobile && carouselButtons}
                </div>

                <div className="HomeCarousel__body">
                    <div className="HomeCarousel__content">
                        <Link
                            to={`${homeRoute}${path}`}
                            className="HomeCarousel__link"
                        >
                            <TransitionGroup
                                component="div"
                                className="HomeCarousel__transition-title"
                            >
                                <CSSTransition
                                    classNames="HomeCarousel__title"
                                    key={`title-${current}`}
                                    timeout={{enter: 500, exit: 500}}
                                >
                                    <span>{title}</span>
                                </CSSTransition>
                            </TransitionGroup>
                        </Link>
                        <Link to={`${homeRoute}${parent.path}`}>
                            <TransitionGroup
                                component="p"
                                className="HomeCarousel__transition-category"
                            >
                                <CSSTransition
                                    classNames="HomeCarousel__category"
                                    key={`category-${current}`}
                                    timeout={{enter: 500, exit: 500}}
                                >
                                    <strong>{parent.name}</strong>
                                </CSSTransition>
                            </TransitionGroup>
                        </Link>
                        <TransitionGroup
                            component="p"
                            className="HomeCarousel__transition-overview"
                        >
                            <CSSTransition
                                classNames="HomeCarousel__overview"
                                key={`overview-${current}`}
                                timeout={{enter: 500, exit: 500}}
                            >
                                <span>{overview}</span>
                            </CSSTransition>
                        </TransitionGroup>
                    </div>
                    {!isMobile && (
                        <div className="HomeCarousel__controls-wrapper">
                            <div className="HomeCarousel__controls">
                                {carouselButtons}
                                <CurrentSlideIndicator
                                    current={current}
                                    numberOfItems={this.numberOfItems}
                                />
                                <CurrentSlideProgressBar
                                    current={current}
                                    numberOfItems={this.numberOfItems}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </section>
        );
    }
}

export default determineIfMobile(HomeCarousel, 500);
export {
    HomeCarousel,
    CarouselButtons,
    CurrentSlideIndicator,
    CurrentSlideProgressBar,
};
